import { spring, SpringHelperConfig } from "react-motion";

export const springIf = (condition: boolean, value: number, config?: SpringHelperConfig) => {
  return condition ? spring(value, config) : value;
};
